import { Component, computed, Input, OnChanges, OnInit, Signal, SimpleChanges, WritableSignal } from '@angular/core';
import { FieldConfig, FiltersDTO, Terms } from 'src/app/models/types/Filters.type';
import { InputComponent } from './input/input.component';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { SharedModule } from 'src/app/modules/shared.module';
import { SelectComponent } from './select/select.component';
import { TypeFilter } from 'src/app/models/enums/TypeFilter.enum';
import { FiltersService } from 'src/app/services/filters.service';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { PriceRangeInputComponent } from './price-range-input/price-range-input.component';

@Component({
  selector: 'app-filters',
  standalone: true,
  templateUrl: './filters.component.html',
  styleUrl: './filters.component.scss',
  imports: [
    SharedModule,
    InputComponent,
    PriceRangeInputComponent,
    MultiSelectComponent
  ]
})
export class FiltersComponent implements OnInit {

  public get TypeFilter() {
    return TypeFilter
  }

  constructor(
    public filtersService: FiltersService,
  ) { }

  ngOnInit(): void {
    this.filtersService.form.valueChanges.subscribe((val => { }));
  }

}
